<template>
  <v-dialog scrollable v-model="hasCubataItem" persistent max-width="750px">
    <v-card class="select-item">
      <v-card-title class="headline grey lighten-2" primary-title>
        {{ $t("modal.chooseYourDrink") }}
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="product-content" style="height: 300px;">
                <div class="product-checkbox" style="height: 300px;">
                  <div
                    class="form-group"
                    v-for="drink in getDrinksByProductTypes()"
                    :key="drink.id"
                    @click="onCheckedClick(drink)"
                  >
                    <input
                      type="checkbox"
                      :checked="isChecked(drink.id)"
                      :value="drink"
                    />
                    <label for="html">
                      <span>{{ drinkName(drink) }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="darken-1"
          text
          @click="$store.commit('toggleItemListModal')"
        >
          {{ $t("common.close") }}
        </v-btn>
        <v-btn
          color="darken-1"
          text
          class="hecho-btn"
          @click="$emit('selectDrink', selectedDrink, cubataItem)"
          :style="[
            { color: colorsGeneralPrimary },
            { borderColor: colorsGeneralPrimary }
          ]"
        >
          {{ $t("common.done") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { drinksCollection } from "@/collections/drinks";
import { productTypesCollection } from "@/collections/productTypes";

export default {
  name: "CubataDialog",
  props: {
    cubataItem: Object
  },
  data() {
    return {
      selectedDrink: null,
      productTypesCollection: []
    };
  },
  firestore() {
    return {
      productTypesCollection: productTypesCollection,
      drinksCollection: drinksCollection.orderBy("name")
    };
  },
  computed: {
    hasCubataItem() {
      return !!this.cubataItem;
    }
  },
  methods: {
    isChecked(id) {
      return !!(this.selectedDrink && this.selectedDrink.id === id);
    },
    getDrinksByProductTypes() {
      return this.drinksCollection.filter(
        drink =>
          drink.product_type_id ===
            process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID &&
          drink.canBeCombined === true
      );
    },
    onCheckedClick(drink) {
      if (this.selectedDrink && this.selectedDrink.id === drink.id) {
        this.selectedDrink = null;
      } else {
        this.selectedDrink = drink;
      }
    },
    drinkName(drink) {
      return drink.isEnergyDrink ? `${drink.name} +1€` : drink.name;
    }
  }
};
</script>

<style></style>
